import { useState } from "react";
import { Search, RefreshCw, History, Plus, ScanLine } from "lucide-react";
import { toast } from "sonner";
import api, { readError } from "../api";
import { STATUS } from "../studioUtils";
import { QuoteHistoryTable } from "../components/QuoteHistoryTable";
import styles from "./QuoteHistory.module.css";

export default function QuoteHistory({ history, search, setSearch, loadHistory, statusFilter, setStatusFilter,
  openQuote, duplicateQuote, reviseQuote, onEmptyNew, updateStatus, isAdmin, deleteQuote,
  sendToCustomer, downloadPdf, sendWhatsApp }) {
  const [scanValue, setScanValue] = useState("");
  const [busyRef, setBusyRef] = useState(null);
  const scanSubmit = async (event) => {
    event.preventDefault();
    const code = scanValue.trim();
    if (!code) return;
    try {
      const { data } = await api.get(`/quotes/by-barcode/${encodeURIComponent(code)}`);
      openQuote(data.ref_code);
      setScanValue("");
    } catch (err) { toast.error(readError(err, "Barkoda uyan teklif yok")); }
  };
  const sendReminder = async (ref) => {
    setBusyRef(ref);
    try {
      const { data } = await api.post(`/quotes/${ref}/send-reminder`);
      toast.success(`Hatırlatma gönderildi: ${data.sent_to}`);
      loadHistory();
    } catch (err) { toast.error(readError(err, "Hatırlatma gönderilemedi")); }
    finally { setBusyRef(null); }
  };
  return <section className={styles.view} data-testid="quote-history-view">
    <div className={styles.toolbar}>
      <form className={styles.search} onSubmit={e => { e.preventDefault(); loadHistory(); }}>
        <Search size={17} aria-hidden="true" />
        <input data-testid="quote-search-input" aria-label="Teklif ara" value={search}
          onChange={e => setSearch(e.target.value)} placeholder="Referans, müşteri, konu, EAN13 ara" />
      </form>
      <select data-testid="status-filter" className={styles.filter} aria-label="Teklif durumuna göre filtrele"
        value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
        <option value="">Tüm durumlar</option>
        {STATUS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
      </select>
      <button data-testid="history-refresh-button" className="outline-button" onClick={loadHistory}>
        <RefreshCw size={15} /> Yenile
      </button>
    </div>
    <form className={styles.scan} onSubmit={scanSubmit}>
      <ScanLine size={18} aria-hidden="true" />
      <input data-testid="scan-input" aria-label="Teklif barkodu" placeholder="EAN13 barkod okut veya kodu yaz"
        value={scanValue} onChange={e => setScanValue(e.target.value)} autoComplete="off" />
      <button className="outline-button" type="submit" data-testid="scan-go">Bul</button>
    </form>
    <div className={styles.listMeta} data-testid="history-result-count">{history.length} teklif</div>
    {history.length === 0 ? <div className="empty-state" data-testid="history-empty-state">
      <History size={30} /><h2>Kayıtlı teklif bulunamadı</h2>
      <p>Aramanıza uyan sonuç yok ya da henüz teklif oluşturulmadı.</p>
      <button data-testid="empty-new-quote-button" className="primary-button" onClick={onEmptyNew}>
        <Plus size={16} /> Yeni teklif oluştur
      </button>
    </div> : <QuoteHistoryTable history={history} openQuote={openQuote} updateStatus={updateStatus}
      actions={{ isAdmin, busyRef, openQuote, duplicateQuote, reviseQuote, sendReminder,
        deleteQuote, sendToCustomer, downloadPdf, sendWhatsApp }} />}
  </section>;
}